import { useEffect, useRef, useState } from "react";

import Guest1Img from "../../assets/images/conversations/ep-58-ravin-mirchandani-guest.webp";
import Guest2Img from "../../assets/images/conversations/ep-58-philip-green-guest.webp";
import ThumbImg  from "../../assets/images/conversations/058.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: pg-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .pg-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }

  .pg-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 — HERO
  ══════════════════════════════════════ */
  .pg-hero {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .pg-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .pg-hero__left {
    display: flex;
    flex-direction: column;
    gap: 44px;
  }
  .pg-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .pg-hero__title.pg-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .pg-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .pg-hero__spotify.pg-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .pg-hero__spotify iframe {
    display: block;
    width: 100%;
    height: 152px;
    border: none;
    border-radius: 12px;
  }
  .pg-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .pg-hero__right.pg-visible {
    opacity: 1;
    transform: translateY(0);
  }

  /* thumbnail */
  .pg-yt-thumb {
    position: relative;
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    display: block;
    background: #000;
  }
  .pg-yt-thumb img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 12px;
    transition: opacity 0.3s ease;
  }
  .pg-yt-thumb:hover img { opacity: 0.85; }
  .pg-yt-thumb__play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: none;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }
  .pg-yt-thumb__play img {
    width: 40px;
    height: 44px;
  }
  .pg-yt-iframe-wrap {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    border-radius: 12px;
    overflow: hidden;
  }
  .pg-yt-iframe-wrap iframe {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 — BODY
  ══════════════════════════════════════ */
  .pg-body {
    padding-bottom: 100px;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .pg-body.pg-visible { opacity: 1; transform: translateY(0); }
  .pg-body__para {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #E2E2E2;
    line-height: 160%;
    margin-bottom: 14px;
  }
  .pg-body__para:last-child { margin-bottom: 0; }

  /* ══════════════════════════════════════
     SECTION 3 — OUR GUEST (2 guests)
  ══════════════════════════════════════ */
  .pg-guest {
    padding-bottom: 100px;
    text-align: center;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .pg-guest.pg-visible { opacity: 1; transform: translateY(0); }
  .pg-guest__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 60px;
  }
  .pg-guest__grid {
    display: flex;
    justify-content: center;
    gap: 60px;
  }
  .pg-guest__card {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    max-width: 445px;
  }
  .pg-guest__photo-bg {
    width: 100%;
    height: 500px;
    background: #743FAC;
    border-radius: 12px;
    overflow: hidden;
  }
  .pg-guest__photo-bg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    display: block;
  }
  .pg-guest__name {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .pg-inner { padding-left: 32px; padding-right: 32px; }
    .pg-hero { padding-top: 32px; padding-bottom: 48px; }
    .pg-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .pg-hero__title { font-size: 24px; }
    .pg-hero__left { gap: 16px; }
    .pg-guest__title { font-size: 24px; margin-bottom: 24px; }
    .pg-guest__grid { gap: 20px; }
    .pg-guest__photo-bg { width: 100%; height: 300px; }
    .pg-guest__name { font-size: 24px; margin-top: 18px; }
    .pg-body__para { font-size: 14px; margin-bottom: 12px; }
    .pg-body { padding-bottom: 48px; }
    .pg-guest { padding-bottom: 48px; }
    .pg-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .pg-inner { padding-left: 16px; padding-right: 16px; }
    .pg-hero { padding-top: 51px; padding-bottom: 30px; }
    .pg-hero__grid { grid-template-columns: 1fr; gap: 40px; }
    .pg-hero__left { gap: 30px; }
    .pg-hero__title { font-size: 30px; }
    .pg-body__para { font-size: 16px; margin-bottom: 10px; }
    .pg-guest__title { font-size: 30px; margin-bottom: 20px; }
    .pg-guest__grid { flex-direction: column; gap: 30px; }
    .pg-guest__card { max-width: 100%; align-items: flex-start; }
    .pg-guest__photo-bg { width: 100%; height: 386px; }
    .pg-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .pg-body { padding-bottom: 30px; }
    .pg-guest { padding-bottom: 30px; }
    .pg-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

/* ─────────────────────────────────────────────
   FADE-UP HOOK
───────────────────────────────────────────── */
function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("pg-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

/* ─────────────────────────────────────────────
   YOUTUBE EMBED
───────────────────────────────────────────── */
const YT_VIDEO_ID = "hF1nTQA4CAs";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);

  if (playing) {
    return (
      <div className="pg-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 58 Philip Green"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="pg-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 58 Philip Green thumbnail" />
      <div className="pg-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   SECTIONS
───────────────────────────────────────────── */
function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);

  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="pg-hero">
      <div className="pg-inner">
        <div className="pg-hero__grid">
          <div className="pg-hero__left">
            <h1 ref={titleRef} className="pg-hero__title">
              EP 58 | Australia &amp; India: Adapting to the New Global Reality | Philip GREEN | Australia's High Commissioner to India
            </h1>
            <div ref={spotifyRef} className="pg-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/7odcCzjGUqXdsNJmSbA9rf?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 58 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="pg-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="pg-body">
      <div className="pg-inner">
        <p className="pg-body__para">
          In this episode, we explore the intersection of policy and industry with a distinguished guest who plays a central role in advancing Australia's engagement with India.
        </p>
        <p className="pg-body__para">
          We are honored to welcome Phil Green, Australia's High Commissioner to India, and a seasoned diplomat with a remarkable career spanning four continents. Over the years, Phil has served as High Commissioner or Ambassador to Germany, Singapore, South Africa, and Kenya, amassing extensive international experience and a deep understanding of global affairs.
        </p>
        <p className="pg-body__para">
          A key figure in shaping Australia's foreign policy, Phil was instrumental in the implementation of the Indo-Pacific strategy following its launch in 2017. He also played a pivotal role in formulating Australia's approach to the Quad—a strategic partnership between Australia, India, Japan, and the United States.
        </p>
        <p className="pg-body__para">
          Phil's contributions extend to advancing clean energy collaboration, having piloted the Australia-Germany Hydrogen Accord in 2021. His career highlights also include serving as International Adviser to former Prime Minister Kevin Rudd and being awarded the Order of Australia medal for his exceptional leadership during the response to the Bali bombings.
        </p>
        <p className="pg-body__para">
          Join us for an insightful discussion on the evolving Australia-India partnership and its critical role in the global energy transition.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="pg-guest">
      <div className="pg-inner">
        <h2 className="pg-guest__title">Our Guest</h2>
        <div className="pg-guest__grid">
          <div className="pg-guest__card">
            <div className="pg-guest__photo-bg">
              <img src={Guest1Img} alt="Ravin Mirchandani" />
            </div>
            <p className="pg-guest__name">Ravin MIRCHANDANI</p>
          </div>
          <div className="pg-guest__card">
            <div className="pg-guest__photo-bg">
              <img src={Guest2Img} alt="Philip Green OAM" />
            </div>
            <p className="pg-guest__name">Philip GREEN OAM</p>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ─────────────────────────────────────────────
   ROOT
───────────────────────────────────────────── */
export default function Ep58PhilipGreen() {
  return (
    <>
      <style>{CSS}</style>
      <div className="pg-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}